import Vue from 'vue'
import App from './App.vue'
import router from './router'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import axios from 'axios'

// 配置 axios 基础 URL
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:5000'

Vue.use(iView)
Vue.prototype.$axios = axios

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
